import api from '@/services/api';

const receiveVersions = (payload) => ({
	type: "RECEIVE_VERSIONS",
	payload,
});

const getVersions = () => {
	return (dispatch, getState) => {
		if (!getState().data.versions) {
			api.get('/versions')
				.then(response => {
					dispatch(receiveVersions(response.data));
				});
		}
	};
};

const receiveRecipients = (payload) => ({
	type: "RECEIVE_RECIPIENTS",
	payload,
});

const getRecipients = () => {
	/*let temp = [
		{ 
			code: 'citizen',
			label: 'Obywatel',
		},
		{ 
			code: 'institution',
			label: 'Instytucja',
		},
		{ 
			code: 'company',
			label: 'Firma',
		},
		{ 
			code: 'media',
			label: 'Media',
		},
		{ 
			code: 'this-authority',
			label: 'Ten urząd',
		},
	];*/

	return dispatch => {
		api.get('/recipients')
			.then(response => {
				dispatch(receiveRecipients(response.data));
			});
	};
};

const receiveTitleTypes = (payload) => {
	return ({
		type: "RECEIVE_TITLE_TYPES",
		payload,
	});
};
const receiveCategories = (payload) => {
	return ({
		type: "RECEIVE_CATEGORIES",
		payload,
	});
};

const getTitleTypes = () => {
	return dispatch => {
		api.get('/title-types')
			.then(response => {
				dispatch(receiveTitleTypes(response.data));
			});
	};
};
const getLetterCategories = () => {
	/*let temp = [
		{ 
			code: 'request',
			label: 'Wniosek',
		},
		{ 
			code: 'reply-to-request',
			label: 'Odpowiedź na wniosek',
		},
		{ 
			code: 'application',
			label: 'Podanie',
		},
		{ 
			code: 'power-of-attorney',
			label: 'Pełnomocnictwo',
		},
		{ 
			code: 'refusal',
			label: 'Odmowa',
		},
		{ 
			code: 'other',
			label: 'Inne',
		},
	];*/

	return dispatch => {
		api.get('/categories')
			.then(response => {
				dispatch(receiveCategories(response.data));
			});
	};
};

const receiveAllTitleTypes = (payload) => {
	return ({
		type: "RECEIVE_ALL_TITLE_TYPES",
		payload,
	});
};
const getAllTitleTypes = () => {
	return dispatch => {
		api.get('/all-title-types')
			.then(response => {
				dispatch(receiveAllTitleTypes(response.data));
			});
	};
};

const receiveAccountTypes = (payload) => {
	return ({
		type: "RECEIVE_ACCOUNT_TYPES",
		payload,
	});
};
const getAccountTypes = () => {
	return dispatch => {
		api.get('/account-types')
			.then(response => {
				dispatch(receiveAccountTypes(response.data));
			});
	};
};

const receiveUserRoles = (payload) => {
	return ({
		type: "RECEIVE_USER_ROLES",
		payload,
	});
};
const getUserRoles = () => {
	return dispatch => {
		api.get('/user-roles')
			.then(response => {
				dispatch(receiveUserRoles(response.data));
			});
	};
};

const receiveMenuResources = (payload) => {
	return ({
		type: "RECEIVE_MENU_RESOURCES",
		payload,
	});
};
const getMenuResources = () => {
	return dispatch => {
		api.get('/resources/menu')
			.then(response => {
				dispatch(receiveMenuResources(response.data));
			});
	};
};

export const dataActions = {
	getVersions,
	getRecipients,
	getTitleTypes,
	getLetterCategories,
	getAllTitleTypes,
	getAccountTypes,
	getUserRoles,
	getMenuResources,
};